/**
 * @generated SignedSource<<1f7564af5bda5d63af5a5d9a5a3c12f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSignupPaymentMethodSelectModal_user$data = {
  readonly squareCards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"SquareCardFragment">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "EventSignupPaymentMethodSelectModal_user";
};
export type EventSignupPaymentMethodSelectModal_user$key = {
  readonly " $data"?: EventSignupPaymentMethodSelectModal_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupPaymentMethodSelectModal_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupPaymentMethodSelectModal_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "enabled",
          "value": true
        }
      ],
      "concreteType": "SquareCardOnFileConnection",
      "kind": "LinkedField",
      "name": "squareCards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareCardOnFileEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareCardOnFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SquareCardFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "squareCards(enabled:true)"
    }
  ],
  "type": "MemberUser",
  "abstractKey": null
};

(node as any).hash = "a8fcb6d5aac3671d0b74f36b473df4ff";

export default node;
